import { Component, Input, EventEmitter, Output, OnChanges, SimpleChanges } from '@angular/core';
import { ModalFormContainerComponent } from '../../ui/modal-form-container/modal-form-container.component';
import { GroupPickerComponent } from '../../organization/contacts/group-picker/group-picker.component';
import { IOrganization } from '../../../types/contactModule';

/**
 * Pick organizations as message or campaign recipients. The choice is a draft
 * until confirmed: closing the dialog leaves the caller's selection as it was.
 */
@Component({
  selector: 'add-organizations-modal',
  standalone: true,
  imports: [ModalFormContainerComponent, GroupPickerComponent],
  templateUrl: './add-organizations-modal.component.html',
  styleUrl: './add-organizations-modal.component.css',
})
export class AddOrganizationsModalComponent implements OnChanges {
  @Input() title: string = 'Choose organizations';
  @Input() open: boolean = false;
  @Input() selection: IOrganization[] = [];
  @Output() close = new EventEmitter();
  @Output() updateSelection = new EventEmitter<IOrganization[]>();

  /** The working copy shown in the picker. */
  draft: IOrganization[] = [];

  ngOnChanges(changes: SimpleChanges) {
    if (changes['open'] || changes['selection']) {
      this.draft = [...(this.selection || [])];
    }
  }

  onPick(items: IOrganization[]) {
    this.draft = items;
  }

  emitSelection() {
    this.updateSelection.emit([...this.draft]);
    this.closeModal();
  }

  closeModal() {
    this.close.emit();
  }
}
